import { validaEmails, validaNames } from "../../helpers/forms/Validation";
import { RESET_SELLER, UPDATE_SELLER } from "./actionTypes";
import * as Yup from "yup";

const sellerBase = {
    id: null,
    name: '',
    last_names: '',
    short_name: ''
}
const initialState = {
    seller: { ...sellerBase },
    validations: {
        name: validaNames(),
        last_names: validaNames(),
        short_name: Yup.string().required('El identificador es obligatorio')
    }
};

const seller = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SELLER:
            // Actualizar el estado
            return {
                ...state,
                seller: action.payload
            };
        case RESET_SELLER:
            return {
                ...state,
                seller: { ...sellerBase }
            };
        default:
            return state;
    }
};

export default seller;
